
<header class="topbar">
  <div>
    <span class="topbar-label">Gerenciamento</span>
    <h1>Nova reserva</h1>
    <p>Cadastre a hospedagem e gere um link de pagamento para o cliente.</p>
  </div>
</header>

<div class="nova-reserva-layout">

  <main class="formulario">

    <section class="painel">
      <div class="painel-titulo">
        <span class="etapa">01</span>
        <div>
          <h2>Dados da hospedagem</h2>
          <p>Escolha a acomodação e o período.</p>
        </div>
      </div>

      <div class="campos">
        <div class="campo largura-total">
          <label for="quarto">Acomodação</label>
          <select
            id="quarto"
            [(ngModel)]="quartoId"
            (ngModelChange)="selecionarQuarto()"
            [disabled]="salvando || reservaCriadaId !== null"
          >
            <option [ngValue]="null">Selecione uma acomodação</option>
            <option *ngFor="let quarto of quartos" [ngValue]="quarto.id">
              {{ quarto.nome }} — até {{ quarto.capacidade }} hóspedes
            </option>
          </select>
        </div>

        <div class="campo">
          <label>Check-in</label>
          <button
            type="button"
            class="campo-botao"
            (click)="abrirCalendario('entrada')"
            [disabled]="salvando || reservaCriadaId !== null || quartoId === null">
            <span>▣</span>
            {{ formatarData(checkIn) }}
          </button>
        </div>

        <div class="campo">
          <label>Check-out</label>
          <button
            type="button"
            class="campo-botao"
            (click)="abrirCalendario('saida')"
            [disabled]="salvando || reservaCriadaId !== null || quartoId === null">
            <span>▣</span>
            {{ formatarData(checkOut) }}
          </button>
        </div>

        <div class="calendario" *ngIf="mostrarCalendario">

          <div class="calendario-header">
            <button type="button" (click)="mesAnterior()">‹</button>

            <strong>
              {{ nomesMeses[mesAtual] }} {{ anoAtual }}
            </strong>

            <button type="button" (click)="mesProximo()">›</button>
          </div>

          <div class="calendario-regra"
               *ngIf="modoCalendario === 'saida' && checkIn">

            <strong>
              Estadia mínima: {{ minimoNoitesSelecionado }}
              {{ minimoNoitesSelecionado === 1 ? 'noite' : 'noites' }}
            </strong>

            <span>
      Primeiro check-out permitido:
              {{ formatarData(checkoutMinimo) }}
    </span>
          </div>

          <div class="calendario-semana">
            <span>Dom</span>
            <span>Seg</span>
            <span>Ter</span>
            <span>Qua</span>
            <span>Qui</span>
            <span>Sex</span>
            <span>Sáb</span>
          </div>

          <div class="calendario-dias">
            <button
              type="button"
              *ngFor="let dia of diasCalendario"
              [class.vazio]="dia.numero === 0"
              [class.hoje]="dia.hoje"
              [class.selecionado]="dia.selecionado"
              [class.intervalo]="dia.intervalo"
              [class.dia-bloqueado]="dia.numero !== 0 && dia.desabilitado"
              [class.dia-checkout-minimo]="modoCalendario === 'saida' && checkoutMinimo === formatarDiaCalendario(dia.data) && !dia.desabilitado"
              [disabled]="dia.numero === 0 || dia.desabilitado"
              (click)="selecionarData(dia)">
              {{ dia.numero || '' }}
            </button>
          </div>

          <div class="calendario-footer">
            {{ modoCalendario === 'entrada'
            ? 'Selecione o check-in'
            : 'Selecione o check-out' }}
          </div>
        </div>
      </div>
    </section>

    <section class="painel">
      <div class="painel-titulo">
        <span class="etapa">02</span>
        <div>
          <h2>Ocupação</h2>
          <p>Informe adultos, crianças e animais.</p>
        </div>
      </div>

      <div class="campos tres-colunas">

        <div class="campo">
          <label>Adultos</label>
          <input
            type="number"
            min="1"
            [max]="quartoSelecionado?.capacidade || 1"
            [(ngModel)]="adultos"
            (ngModelChange)="alterarOcupacao()"
            [disabled]="salvando || reservaCriadaId !== null || quartoId === null"
          />
        </div>

        <div class="campo">
          <label>Crianças</label>
          <input
            type="number"
            min="0"
            [max]="(quartoSelecionado?.capacidade || 1) - adultos"
            [(ngModel)]="criancas"
            (ngModelChange)="alterarOcupacao()"
            [disabled]="salvando || reservaCriadaId !== null || quartoId === null"
          />
        </div>

        <div class="campo">
          <label>Pets</label>
          <input
            type="number"
            min="0"
            max="2"
            [(ngModel)]="animais"
            (ngModelChange)="alterarOcupacao()"
            [disabled]="salvando || reservaCriadaId !== null || quartoId === null"
          />
        </div>

      </div>
    </section>

    <section class="painel">
      <div class="painel-titulo">
        <span class="etapa">03</span>
        <div>
          <h2>Dados dos hóspedes</h2>
          <p>O primeiro hóspede será o responsável pelo pagamento.</p>
        </div>
      </div>

      <div
        class="hospede-card"
        *ngFor="let hospede of hospedes; let i = index"
      >
        <h3>
          Hóspede {{ i + 1 }}
          <small *ngIf="i === 0">Responsável</small>
        </h3>

        <div class="campos">
          <div class="campo">
            <label>Nome</label>
            <input type="text" [(ngModel)]="hospede.nome"
                   maxlength="50" [disabled]="salvando || reservaCriadaId !== null"/>
          </div>

          <div class="campo">
            <label>Sobrenome</label>
            <input type="text" [(ngModel)]="hospede.sobrenome"
                   maxlength="50" [disabled]="salvando || reservaCriadaId !== null"/>
          </div>

          <div class="campo">
            <label>Telefone</label>
            <input
              type="tel"
              [ngModel]="formatarTelefone(hospede.telefone)"
              (ngModelChange)="hospede.telefone = somenteNumeros($event, 11)"
              [disabled]="salvando || reservaCriadaId !== null"
            />
          </div>

          <div class="campo" *ngIf="i === 0">
            <label>E-mail</label>
            <input type="email" [(ngModel)]="hospede.email"
                   [disabled]="salvando || reservaCriadaId !== null"/>
          </div>

          <div class="campo" *ngIf="i === 0">
            <label>CPF</label>
            <input
              type="text"
              [ngModel]="formatarCpf(hospede.cpf)"
              (ngModelChange)="hospede.cpf = somenteNumeros($event, 11)"
              [disabled]="salvando || reservaCriadaId !== null"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="painel">
      <div class="painel-titulo">
        <span class="etapa">04</span>
        <div>
          <h2>Pacotes e desconto</h2>
          <p>Adicione serviços opcionais à hospedagem.</p>
        </div>
      </div>

      <div class="pacotes-lista" *ngIf="pacotesDisponiveis.length">
        <label class="pacote" *ngFor="let pacote of pacotesDisponiveis">
          <input
            type="checkbox"
            [checked]="pacotesSelecionados.includes(pacote.id)"
            (change)="alternarPacote(pacote.id)"
            [disabled]="salvando || reservaCriadaId !== null"
          />
          <span class="pacote-info">
            <strong>{{ pacote.nome }}</strong>
            <small>{{ pacote.descricao }}</small>
          </span>
          <strong class="pacote-preco">
            {{ pacote.valor | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
          </strong>
        </label>
      </div>

      <p class="vazio" *ngIf="!pacotesDisponiveis.length">
        Nenhum pacote disponível para esta acomodação.
      </p>

      <div class="campo campo-cupom">
        <label>Cupom de desconto</label>
        <input
          type="text"
          placeholder="Código do cupom (opcional)"
          [(ngModel)]="codigoCupom"
          [disabled]="salvando || reservaCriadaId !== null"
        />
      </div>
    </section>

  </main>

  <aside class="resumo">
    <div class="resumo-card">
      <span class="resumo-etiqueta">RESUMO DA RESERVA</span>
      <h2>{{ quartoSelecionado?.nome || 'Selecione a acomodação' }}</h2>

      <div class="resumo-item">
        <span>Check-in</span>
        <strong>{{ checkIn || '—' }}</strong>
      </div>

      <div class="resumo-item">
        <span>Check-out</span>
        <strong>{{ checkOut || '—' }}</strong>
      </div>

      <div class="resumo-item">
        <span>Noites</span>
        <strong>{{ quantidadeNoites }}</strong>
      </div>

      <div class="resumo-item">
        <span>Hóspedes</span>
        <strong>{{ quantidadeHospedes }}</strong>
      </div>

      <div class="resumo-item">
        <span>Animais</span>
        <strong>{{ animais }}</strong>
      </div>

      <div class="prazo">
        <strong>Pagamento via Asaas</strong>
        <p>O cliente receberá um link para pagamento por Pix ou cartão, conforme as opções disponibilizadas pelo Asaas.</p>
        <span>Prazo administrativo: 24 horas</span>
      </div>

      <button
        *ngIf="reservaCriadaId === null"
        class="btn-principal"
        type="button"
        [disabled]="salvando || carregando"
        (click)="criarReserva()"
      >
        {{ salvando ? 'Processando...' : 'Criar reserva e gerar link' }}
      </button>

      <button
        *ngIf="reservaCriadaId !== null && !linkPagamento"
        class="btn-principal"
        type="button"
        [disabled]="salvando"
        (click)="gerarLink(reservaCriadaId)"
      >
        {{ salvando ? 'Gerando...' : 'Tentar gerar link novamente' }}
      </button>

      <div class="link-gerado" *ngIf="linkPagamento as link">
        <strong>Reserva #{{ link.reservaId }}</strong>
        <p>Link de pagamento gerado com sucesso.</p>

        <input
          type="text"
          readonly
          [value]="link.invoiceUrl"
          aria-label="Link de pagamento"
        />

        <button type="button" class="btn-principal" (click)="copiarLink()">
          Copiar link
        </button>

        <button type="button" class="btn-secundario" (click)="abrirLink()">
          Abrir pagamento
        </button>

        <small>Prazo local: {{ link.expiraEm | date:'dd/MM/yyyy HH:mm' }}</small>
      </div>
    </div>
  </aside>
</div>
